// TODO: Remove in favour of the nova-price component
import { LitElement, classMap, css, html, nothing } from '@lit'
import styles from '@nova/styles'

class ProductCardPrice extends LitElement {
  static properties = {
    price: { type: String },
    compareAtPrice: { type: String },
  }

  constructor() {
    super()
    this.price = ''
    this.compareAtPrice = ''
  }

  render() {
    return html`
      <span>
        <div class=${classMap({
          price: true,
          'price--on-sale': this.compareAtPrice,
        })}>
          <dl>
            <div class="price__regular">
              <dt>
                <span class="visually-hidden visually-hidden--inline">
                  Regular price
                </span>
              </dt>
              <dd>
                <span class="price-item price-item--regular" part="product-regular-price-element">
                  ${this.price}</span>
              </dd>
            </div>
            ${
              this.compareAtPrice
                ? html`
                  <div class="price__sale ">
                    <dt class="price__compare">
                      <span class="visually-hidden visually-hidden--inline">
                        Sale price
                      </span>
                    </dt>
                    <dd class="price__compare">
                      <span class="price-item price-item--regular" part="product-regular-price-element">
                      ${this.compareAtPrice}
                      </span>
                    </dd>
                    <dt>
                      <span class="visually-hidden visually-hidden--inline">
                        Regular price
                      </span>
                    </dt>
                    <dd>
                      <span class="price-item price-item--sale">
                        ${this.price}
                      </span>
                    </dd>
                  </div>
                `
                : nothing
            }
          </dl>
        </div>
      </span>
    `
  }

  static styles = [
    styles.reset,
    styles.a11y,
    styles.flex,
    styles.helpers,
    styles.typography,
    styles.skeleton,
    css`
      .price {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        color: rgb(var(--color-foreground));
      }

      .price-item {
        font: var(--nova-body-font);
        font-size: 14px;
        line-height: 1.35;
      }

      .price--align-left {
        align-items: flex-start;
      }

      .price.price--unavailable {
        visibility: hidden;
      }

      .price--end {
        justify-content: flex-end;
      }

      .price dd { margin: auto; }

      .price dl {
        margin: 0;
        display: flex;
        flex-direction: column;
      }

      .price .price__last:last-of-type {
        margin: 0;
      }

      @container (min-width: 300px) {
        .price {
          margin-bottom: 0;
        }
      }

      .price--sold-out .price__availability,
      .price__regular {
        display: block;
      }

      .price__sale,
      .price__availability,
      .price .price__badge-sale,
      .price .price__badge-sold-out,
      .price--on-sale .price__regular,
      .price--on-sale .price__availability,
      .price--no-compare .price__compare {
        display: none;
      }

      .price--sold-out .price__badge-sold-out,
      .price--on-sale .price__badge-sale {
        display: inline-flex;
      }

      .price__sale dd + dt {
        margin-right: 5px;
      }

      .price--on-sale .price__sale {
        display: flex;
        flex-direction: row-reverse;
      }

      .price--center {
        display: flex;
        justify-content: center;
      }

      .price--on-sale .price-item--regular {
        text-decoration: line-through;
        color: var(--nova-color-black);
      }

      .price--on-sale .price-item--sale {
        color: var(--nova-color-danger);
      }
    `,
  ]
}

customElements.define('nova-product-card-price', ProductCardPrice)
